import { useLocation, useNavigate } from "react-router-dom";
import { usePendingIntent } from "@/contexts/PendingIntentContext";
import { LOGIN } from "@/routes";
import { isAndroid, isNativeApp } from "@/utils/platform-detection";
import { CONTROL } from "@/lib/typography";
import { cn } from "@/lib/utils";

/**
 * What signed-out visitors to public stashes, stuff and collections see: the logo
 * and sign-up, which returns them to this page. Signed in, navigation is the menu.
 */
export const SignedOutHeader = () => {
  const { setIntent } = usePendingIntent();
  const location = useLocation();
  const navigate = useNavigate();
  const paddingTop = isNativeApp() && isAndroid() ? "max(24px, var(--sat, 24px))" : "var(--sat)";

  return (
    <header
      className="w-full border-b border-border bg-background desktop:sticky desktop:top-0 desktop:z-50"
      style={{ paddingTop }}
    >
      <div className="flex w-full items-center justify-between gap-4 px-4 py-2.5 desktop:px-12 desktop:py-4">
        <a href="https://stasht.app" className="flex shrink-0 items-center" aria-label="Go to Stasht homepage">
          <img alt="" src="/stasht-icon-circle.svg" className="h-10 w-10 desktop:hidden" />
          <img
            alt="Stasht logo"
            src="/Stasht full Horrizontal.png"
            width={374}
            height={101}
            className="hidden h-7 w-auto desktop:block"
          />
        </a>
        <button
          type="button"
          onClick={() => {
            setIntent(location.pathname + location.search);
            navigate(LOGIN());
          }}
          className={cn(CONTROL, "rounded-full border border-foreground bg-foreground px-4 py-2 text-background transition")}
        >
          Signup Free or Login
        </button>
      </div>
    </header>
  );
};
